import React from 'react';
import { Route } from 'react-router-dom';
import { Layout, Row, Col, ConfigProvider } from 'antd';
import { getTheme } from '../../theme-antd';
import { useTheme } from '../../ThemeContext';
import LoginFooter from '../../components/login/LoginFooter';
import LoginIllustration from '../../components/login/LoginIllustration';
import './AntdLoginLayout.css';

const { Content } = Layout;

const AntdLoginLayout = ({ component: Component, ...rest }) => {
  const { isDarkMode } = useTheme();

  return (
    <Route
      {...rest}
      render={matchProps => (
        <ConfigProvider theme={getTheme(isDarkMode)}>
          <Layout className="antd-login-layout">
            <Content className="login-content">
              <Row className="full-height">
                <Col xs={0} lg={12} className="illustration-column">
                  <LoginIllustration />
                </Col>
                <Col xs={24} lg={12} className="form-column">
                  <div className="login-form-container">
                    <Component {...matchProps} />
                  </div>
                </Col>
              </Row>
            </Content>
            <LoginFooter />
          </Layout>
        </ConfigProvider>
      )}
    />
  );
};

export default AntdLoginLayout;
